import React, { useEffect } from 'react';
import _ from 'lodash';
import {
  Divider,
  Grid,
  Header,
  Input,
  Segment,
  Table
} from 'semantic-ui-react';
import { history } from '../../_helpers';
import { useUsers } from '../../_services';
import { copyToClipboard } from '../../utils';

export const ListUsers = () => {
  const users = useUsers();

  const [userNameFilter, setForenameFilter] = React.useState('');
  const [roleFilter, setRoleFilter] = React.useState('');
  const [statusFilter, setStatusFilter] = React.useState('Active');

  const [sortColumn, setSortColumn] = React.useState(null);
  const [sortDirection, setSortDirection] = React.useState('desc');
  const [sortLabel, setSortLabel] = React.useState('descending');
  const [sortedData, setSortedData] = React.useState([]);

  const sortTable = column => {
    setSortColumn(column);
    setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    setSortLabel(sortLabel === 'ascending' ? 'descending' : 'ascending');
  };

  useEffect(() => {
    sortTable('user_name');
  }, []);

  useEffect(() => {
    if (users.length === 0) return;

    const sorted =
      sortColumn && sortDirection
        ? _.orderBy(users, sortColumn, sortDirection)
        : users;
    setSortedData(
      sorted
        .filter(
          ({ user_name }) =>
            !userNameFilter ||
            user_name.toLowerCase().includes(userNameFilter.toLowerCase())
        )
        .filter(
          ({ role }) =>
            !roleFilter || role.toLowerCase().includes(roleFilter.toLowerCase())
        )
        .filter(({ status }) => !statusFilter || status.includes(statusFilter))
    );
  }, [
    users,
    userNameFilter,
    roleFilter,
    statusFilter,
    sortColumn,
    sortDirection
  ]);

  return (
    <Segment>
      <Grid stretched>
        <Grid.Row>
          <Grid.Column>
            <Header as="h2">Users</Header>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column mobile={8} tablet={6} computer={4}>
            <Input
              type="text"
              placeholder="filter forename"
              icon={{
                name: 'close',
                link: true,
                onClick: () => {
                  setForenameFilter('');
                }
              }}
              value={userNameFilter}
              onChange={(event, { value }) => {
                setForenameFilter(value);
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={8} tablet={6} computer={4}>
            <Input
              type="text"
              placeholder="filter role"
              icon={{
                name: 'close',
                link: true,
                onClick: () => {
                  setRoleFilter('');
                }
              }}
              value={roleFilter}
              onChange={(event, { value }) => {
                setRoleFilter(value);
              }}
            />
          </Grid.Column>
          <Grid.Column mobile={8} tablet={6} computer={4}>
            <Input
              type="text"
              placeholder="filter status"
              icon={{
                name: 'close',
                link: true,
                onClick: () => {
                  setStatusFilter('');
                }
              }}
              value={statusFilter}
              onChange={(event, { value }) => {
                setStatusFilter(value);
              }}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Divider hidden />
      <Grid>
        <Table sortable celled fixed>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell
                sorted={sortColumn === 'id' ? sortLabel : null}
                onClick={() => sortTable('id')}
                style={{ width: '130px' }}
              >
                User ID
              </Table.HeaderCell>
              <Table.HeaderCell
                sorted={sortColumn === 'user_name' ? sortLabel : null}
                onClick={() => sortTable('user_name')}
                style={{ width: '120px' }}
              >
                Email
              </Table.HeaderCell>
              <Table.HeaderCell
                sorted={sortColumn === 'role' ? sortLabel : null}
                onClick={() => sortTable('role')}
                style={{ width: '110px' }}
              >
                Roles
              </Table.HeaderCell>
              <Table.HeaderCell
                sorted={sortColumn === 'status' ? sortLabel : null}
                onClick={() => sortTable('status')}
                style={{ width: '80px' }}
              >
                Status
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {sortedData.map(d => (
              <Table.Row
                key={d.id}
                onClick={() => {
                  copyToClipboard(d.id);
                  history.push(`/admin/customer/${d.id}`);
                }}
              >
                <Table.Cell>{d.id}</Table.Cell>
                <Table.Cell>{d.user_name}</Table.Cell>
                <Table.Cell>{d.roles}</Table.Cell>
                <Table.Cell>{d.status}</Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </Grid>
    </Segment>
  );
};
